// extracted by mini-css-extract-plugin
module.exports = {"word":"SplitText_word__LpXF6","letter":"SplitText_letter__QFEQ5","emptySpace":"SplitText_emptySpace__S5Zcy","marks":"SplitText_marks__qfTYL"};